import axios from "axios";
import { getAPIURL } from './';
axios.defaults.withCredentials = true;

/**
 * Get the context of the app.
 * Auth required
 */
export const getAppContext = (): Promise<any> => {
  return axios.get<any>(getAPIURL('Context/GetAppContext')).then(response => {
    return response.data;
  });
};

/**
 * Authenticate the user
 * @param {string} userName
 * @param {string} password
 */
export const authenticateUser = (userName, password): Promise<{message: string, successful: boolean}> => {
  return axios
    .post<boolean>(getAPIURL('Users/Authenticate'), {
      Username: userName,
      Password: password,
    })
    .then((resp) => {
      return {
        message: '',
        successful: true
      }
    })
    .catch(function (error) {
      if (error.response) {
        return {
          message: error.response.data.message,
          successful: false
        };
      } else if (error.request) {
        // The request was made but no response was received
        //console.log(error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        //console.log('Error', error.message);
      }

      return {
        message: 'Unable to authenticate',
        successful: false
      };  
    });
};

export const signOut = () : Promise<Boolean> => {
  return axios.get<any>(getAPIURL('Context/SignOut')).then(response => {
    console.log('sign out', response);
    return true;
  });
};